import { Box, Paper } from '@mui/material'
import { useContext } from 'react'

import { QuadkeyMap } from '../../Components'
import { MinterAuctionContext } from '../../Contexts'

const LiveView: React.FC = () => {
  const { quadkey } = useContext(MinterAuctionContext)

  const size = '80vmin'

  return (
    <Box alignItems="center" display="flex" flexDirection="column" justifyContent="center">
      <Box height={size} justifyContent="center" margin="2px" width={size}>
        {quadkey ? <QuadkeyMap crop={true} imgSize={size} quadkey={quadkey} size={512} /> : null}
      </Box>
      <Box sx={{ display: { md: 'flex', xs: 'none' } }} position="absolute">
        <Paper style={{ opacity: 0.8 }}></Paper>
      </Box>
    </Box>
  )
}

export default LiveView
